// extracted by mini-css-extract-plugin
module.exports = {"waiting":"ordersPage_awaitOrderItems_waiting__2Lq26","loadingGrid":"ordersPage_awaitOrderItems_loadingGrid__1qGi9"};